import { useTranslation } from 'react-i18next';
import TableEmptyRow from 'components/others/TableEmptyRow';
import ExpensesTableRow from './ExpensesTableRow';
import type { IncomeExpenseRow } from '../model';

interface ExpensesTableBodyProps {
    rows: IncomeExpenseRow[];
    readOnly: boolean;
    deletingId: number | null;
    onDelete: (row: IncomeExpenseRow) => void;
}

const ExpensesTableBody = ({ rows, readOnly, deletingId, onDelete }: ExpensesTableBodyProps) => {
    const { t } = useTranslation(['Objects']);

    if (!rows.length) {
        return (
            <tbody>
                <TableEmptyRow colSpan={5} className="text-center text-muted py-4">
                    {t('expendTeamExpenses.empty')}
                </TableEmptyRow>
            </tbody>
        );
    }

    return (
        <tbody>
            {rows.map((row) => (
                <ExpensesTableRow
                    key={row.ID}
                    row={row}
                    readOnly={readOnly}
                    deleting={deletingId === row.ID}
                    deleteLocked={deletingId != null}
                    onDelete={onDelete}
                />
            ))}
        </tbody>
    );
};

export default ExpensesTableBody;
